var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSundialLogoTitle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 189.268,
    height: 49.999,
    viewBox: "0 0 189.268 49.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 0.977,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa9c2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    stopColor: "#814d55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d0b77"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ralvie_Logo",
    "data-name": "ralvie Logo",
    transform: "translate(-407.178 -362.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_105",
    "data-name": "Subtraction 105",
    d: "M21.666,50h0Zm-1.716-.067h0a21.464,21.464,0,0,1-7.826-2.142A21.678,21.678,0,0,1,1.661,20H15a5,5,0,1,1,0,10H5.452L8.529,34.23,10.3,36.666,19.95,49.931ZM26.3,49.5h0L16.861,36.519A11.666,11.666,0,0,0,15,13.334H6.031a21.705,21.705,0,0,1,6.992-4.875,21.5,21.5,0,0,1,4.162-1.329,21.865,21.865,0,0,1,8.847-.024,21.544,21.544,0,0,1,7.747,3.26A21.732,21.732,0,0,1,41.63,19.9a21.53,21.53,0,0,1,1.262,4.067,21.684,21.684,0,0,1-9.82,22.791A21.5,21.5,0,0,1,26.3,49.5ZM24.166,5h-5A2.5,2.5,0,0,1,17.4.732,2.483,2.483,0,0,1,19.166,0h5a2.5,2.5,0,0,1,1.768,4.268A2.482,2.482,0,0,1,24.166,5Z",
    transform: "translate(407.178 362.997)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_407",
    "data-name": "Union 407",
    d: "M0,36.666V10.389H4.59v4.327A10.332,10.332,0,0,1,13.666,9.6v4.538a4,4,0,0,0-.792-.053c-5.012.159-8.284,3.483-8.284,8.654v13.93ZM103,22.625c0-8.031,5.638-14.041,13.4-14.041,8.137,0,12.871,6.383,12.871,13.137a11.284,11.284,0,0,1-.16,2.287H107.3c.638,6.223,5.159,8.829,9.573,8.829a8.786,8.786,0,0,0,7.712-4.1l3.3,2.234a12.6,12.6,0,0,1-11.062,5.691C108.58,36.666,103,30.762,103,22.625Zm4.414-2.181h17.6c-.426-4.148-3.351-8.084-8.563-8.084A9.194,9.194,0,0,0,107.41,20.444ZM92.418,36.666V10.179h4.628V36.666ZM60.265,9.115H65.1l9.148,19.147L83.348,9.115h4.787L74.2,36.666Zm-8.8,27.55V0H56.1V36.666Zm-12.635,0v-6.01a11.672,11.672,0,0,1-10.318,6.01C20.8,36.666,15,30.709,15,22.731,15,14.593,20.85,8.584,28.669,8.584A11.369,11.369,0,0,1,38.88,14.647l4.415-6.754V36.666Zm-19.2-13.988A9.392,9.392,0,0,0,29.2,32.464a9.84,9.84,0,0,0,.106-19.679A9.5,9.5,0,0,0,19.627,22.678ZM91.3,3.458A3.439,3.439,0,0,1,94.705,0a3.521,3.521,0,0,1,3.457,3.458,3.511,3.511,0,0,1-3.457,3.4A3.393,3.393,0,0,1,91.3,3.458Z",
    transform: "translate(467.176 369.995)",
    fill: "#1d0b77"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSundialLogoTitle);
export default __webpack_public_path__ + "static/media/sundial_logo_title.f049d9f1842b067465af6825acc5fd11.svg";
export { ForwardRef as ReactComponent };